<template>
  <ReportFilterSelect
    v-model="modelValue"
    label="Merchant"
    :options="merchantOptions"
  />
</template>

<script setup lang="ts">
const modelValue = defineModel<string | undefined>({
  required: true,
})

const { data: merchantResp } = useMerchantGroupMerchants()

const merchantOptions = computed(
  () =>
    merchantResp.value?.merchants.map((m) => ({
      value: m.schemaName,
      label: m.merchantName,
    })) ?? []
)
</script>
